"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWizardSummaryFieldsets = void 0;
require("../../core");
const getWizardSummaryFieldsets = (summaryData) => {
    return summaryData.map((item) => (Object.assign(Object.assign({}, item), { fields: item.fields.map((fieldItem) => ({
            hidden: fieldItem.hidden,
            label: fieldItem.label,
            value: fieldItem.value,
        })) })));
};
exports.getWizardSummaryFieldsets = getWizardSummaryFieldsets;
//# sourceMappingURL=getWizardSummaryFieldsets.js.map